// extracted by mini-css-extract-plugin
module.exports = {"sp_form__row":"SwapPlan_sp_form__row__2RfKo","sp_form__row_sm":"SwapPlan_sp_form__row_sm__1SQPS","sp_form__btns":"SwapPlan_sp_form__btns__18OV4"};